import http from "@/http/http.js";

let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/action/fbQuery/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/action/fbQuery/springBoard';
}
// 精确检索
// export function exactSearch(params) {
//   return http.post(baseURL, {
//       actionType: 'exactSearch',
//       actionBody: params
//   })
// }

// 条件搜索(获取 list)
export function listSearch(params) {
    return http.post(baseURL, {
        actionType: 'getList',
        actionBody: params
    })
  }

// 获取许可证详情
export function getDetail(params) {
  return http.post(baseURL, {
      actionType: 'getDetail',
      actionBody: params
  })
}
